import { EnabledDisabled } from '@reliance/types/enums/EnabledDisabled';
import { HousingUnit } from '@reliance/types/models/HousingUnit';
import { ItdsMode } from '../enums/ItdsMode';

export interface IFacility {
  id: number;
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  timezone: string;
  externalId: string;
  features: string[];
  featureTexting: boolean;
  visitationSchedulingEnabled: boolean;
  configurations: IFacilityConfiguration[];
  communicationsEnabled: boolean;
  textingLocalStatus: EnabledDisabled;
  audioCallingEnabled: boolean;
  videoCallingEnabled: boolean;
  musicEnabled: boolean;
  referenceMaterialEnabled: boolean;
  itdsMode?: ItdsMode;
  housingUnits: HousingUnit[];
}

interface IFacilityConfiguration {
  id: number;
  key: string;
  value: string;
}

export class Facility implements IFacility {
  id: number;
  externalId: string;

  features: string[];
  featureTexting: boolean;
  visitationSchedulingEnabled: boolean;

  configurations: IFacilityConfiguration[];

  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;

  timezone: string;

  communicationsEnabled: boolean;
  textingLocalStatus: EnabledDisabled;
  audioCallingEnabled: boolean;
  videoCallingEnabled: boolean;
  musicEnabled: boolean;
  referenceMaterialEnabled: boolean;

  itdsMode?: ItdsMode;
  housingUnits: HousingUnit[];

  constructor(data: IFacility) {
    this.id = data.id;
    this.features = data.features;
    this.featureTexting = data.featureTexting;
    this.visitationSchedulingEnabled = stringToBoolean(
      (data.visitationSchedulingEnabled || 'false').toString()
    );
    this.configurations = Array.isArray(data.configurations)
      ? data.configurations
      : [];
    this.name = data.name;
    this.address = data.address;
    this.city = data.city;
    this.state = data.state;
    this.zip = data.zip;
    this.timezone = data.timezone;
    this.communicationsEnabled = data.communicationsEnabled;
    this.textingLocalStatus = data.textingLocalStatus;
    this.audioCallingEnabled = data.audioCallingEnabled;
    this.videoCallingEnabled = data.videoCallingEnabled;
    this.referenceMaterialEnabled = data.referenceMaterialEnabled;
    this.musicEnabled = data.musicEnabled;
    this.itdsMode = data.itdsMode;
    this.housingUnits = data.housingUnits;
  }

  getConfigurationValue(key: string) {
    const matches = this.configurations.filter(
      (c) => c.key.toLowerCase() == key.toLowerCase()
    );
    if (matches.length > 0) {
      return matches[0].value;
    }
    return null;
  }
}

function stringToBoolean(val: string) {
  switch (val.toLowerCase()) {
    case 'true':
    case '1':
      return true;
    default:
      return false;
  }
}
